module.exports = __webpack_public_path__ + "static/media/sg1cr64.3f017dc2.png";